import * as React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon';
import { SvgIconProps as DefaultSvgIconProps } from '@material-ui/core/SvgIcon';
import { useTheme } from '@material-ui/core/styles';

export const WeightIcon = (props: DefaultSvgIconProps) => {
  const theme = useTheme();
  return (
    <SvgIcon {...props} viewBox="0 0 13.516 13.735">
      <g transform="translate(631.96 -85.233)">
        <path
          d="M-619.532,180.818H-630.87a.984.984,0,0,1-.758-.355.984.984,0,0,1-.213-.809l1.487-8.177a.987.987,0,0,1,.971-.81h8.364a.987.987,0,0,1,.971.81l1.487,8.177a.984.984,0,0,1-.213.809A.984.984,0,0,1-619.532,180.818Zm-9.851-9.305a.141.141,0,0,0-.139.116l-1.487,8.177a.139.139,0,0,0,.03.116.14.14,0,0,0,.108.051h11.338a.14.14,0,0,0,.108-.051.138.138,0,0,0,.031-.115l-1.487-8.177a.142.142,0,0,0-.139-.116h-8.365Z"
          transform="translate(0 -81.95)"
          fill={props.color || theme.palette.primary.main}
          stroke={props.color || theme.palette.primary.main}
          strokeWidth="0.2"
        />
        <path
          d="M-511.8,89.281a1.976,1.976,0,0,1-1.974-1.974,1.976,1.976,0,0,1,1.974-1.974,1.976,1.976,0,0,1,1.974,1.974A1.976,1.976,0,0,1-511.8,89.281Zm0-3.1a1.129,1.129,0,0,0-1.128,1.128,1.129,1.129,0,0,0,1.128,1.128,1.129,1.129,0,0,0,1.128-1.128A1.129,1.129,0,0,0-511.8,86.179Z"
          transform="translate(-113.397)"
          fill={props.color || theme.palette.primary.main}
          stroke={props.color || theme.palette.primary.main}
          strokeWidth="0.2"
        />
        <g transform="translate(0.392)">
          <path
            d="M-512.548,87.793a1.231,1.231,0,0,1-1.23-1.23,1.231,1.231,0,0,1,1.23-1.23,1.231,1.231,0,0,1,1.23,1.23A1.231,1.231,0,0,1-512.548,87.793Zm0-1.933a.7.7,0,0,0-.7.7.7.7,0,0,0,.7.7.7.7,0,0,0,.7-.7A.7.7,0,0,0-512.548,85.86Z"
            transform="translate(-114.397 7.488)"
            fill={props.color || theme.palette.primary.main}
            stroke={props.color || theme.palette.primary.main}
            strokeWidth="0.2"
          />
          <path
            d="M-512.548,87.793a1.231,1.231,0,0,1-1.23-1.23,1.231,1.231,0,0,1,1.23-1.23,1.231,1.231,0,0,1,1.23,1.23A1.231,1.231,0,0,1-512.548,87.793Zm0-1.933a.7.7,0,0,0-.7.7.7.7,0,0,0,.7.7.7.7,0,0,0,.7-.7A.7.7,0,0,0-512.548,85.86Z"
            transform="translate(-111.397 7.488)"
            fill={props.color || theme.palette.primary.main}
            stroke={props.color || theme.palette.primary.main}
            strokeWidth="0.2"
          />
        </g>
      </g>
    </SvgIcon>
  );
};
